import { render, staticRenderFns } from "./resetPayPassword.vue?vue&type=template&id=269506e4&scoped=true"
import script from "./resetPayPassword.vue?vue&type=script&lang=js"
export * from "./resetPayPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPayPassword.vue?vue&type=style&index=0&id=269506e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269506e4",
  null
  
)

export default component.exports